import { render, staticRenderFns } from "./EditarCotizacion.vue?vue&type=template&id=6b0b924d&"
import script from "./EditarCotizacion.vue?vue&type=script&lang=js&"
export * from "./EditarCotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports